import { render, staticRenderFns } from "./CatalogCert.vue?vue&type=template&id=f1abde4e&scoped=true&"
import script from "./CatalogCert.vue?vue&type=script&lang=js&"
export * from "./CatalogCert.vue?vue&type=script&lang=js&"
import style0 from "./CatalogCert.vue?vue&type=style&index=0&id=f1abde4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1abde4e",
  null
  
)

export default component.exports